import { render, staticRenderFns } from "./RankSlider.vue?vue&type=template&id=47518a6e&scoped=true&"
import script from "./RankSlider.vue?vue&type=script&lang=ts&"
export * from "./RankSlider.vue?vue&type=script&lang=ts&"
import style0 from "./RankSlider.vue?vue&type=style&index=0&id=47518a6e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47518a6e",
  null
  
)

export default component.exports